function planSamplingHeaderDirective() {
	return {
		scope : {
			idPlanSampling: '=',
			idSampling: '=?',
		},
		restrict : 'E',
		replace : true,
		templateUrl : function(elem, attr) {
			return 'views/directives/planSamplingHeaderDirective.html';
		},
		controller : [ '$scope', '$window', 'alertService', 'planSamplingService', 'securityService', function($scope, $window, alertService, planSamplingService, securityService) {
			$scope.planSampling = null;
			$scope.sampling = null;

			
			if (securityService.hasRole(ROLE_TYPE.CLIENT.code)) {
				$scope.loadPlanSampling = function(idPlanSampling) {
					planSamplingService.getPlanSamplingForClientUser(idPlanSampling).then(function(response) {
						$scope.planSampling = response.getData();
	                }, function(response) {
	                	//on error
	                });
				};
			}
			else{
				$scope.loadPlanSampling = function(idPlanSampling) {
					planSamplingService.getPlanSampling(idPlanSampling).then(function(response) {
						$scope.planSampling = response.getData();
	                }, function(response) {
	                	//on error
	                });
				};
			}
			
			
			$scope.loadSampling = function(idPlanSampling, idSampling) {
				if(idPlanSampling && idSampling){
					planSamplingService.getSamplingBasicInfo(idPlanSampling, idSampling).then(function(response) {
						$scope.sampling = response.getData();
	                }, function(response) {
	                	//on error
	                });
				}
			};
			
			$scope.loadPlanSampling($scope.idPlanSampling);
			$scope.loadSampling($scope.idPlanSampling, $scope.idSampling);

		} ],
		link : function(scope, elem, attr) {
			
		}
	};
};

module.directive('planSamplingHeader', [ planSamplingHeaderDirective ]);